import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";

import { Select, Spin, Tag, Tooltip } from "antd";
// import dayjs from "dayjs";
// import { all_routes } from "../../../../../../Router/all_routes";

import CommonFooter from "../../../../../../core/common/footer/commonFooter";
// import { Edit, Eye, Trash2 } from "feather-icons-react/build/IconComponents";


import dayjs from "dayjs";
import { BASE_CRM_URL } from "../../../../../components/config/config";
import Swal from "sweetalert2";
import axios from "axios";
import Table from "../../../../../../core/pagination/datatable";

const ProposalsTab = () => {
  const proposalStatusColors = {
    Sent: "green",
    Pending: "orange",
    Declined: "red",
    Draft: "blue",
    Accepted: "success",
    Default: "default",
  };

  const [proposalStatusOptions, setProposalStatusOptions] = useState([]);

  const getProposalStatuses = async () => {
    try {
      const response = await fetch(
        `${BASE_CRM_URL}proposal/GetProposalsStatus`,
      );

      const data = await response.json();

      if (data.Status) {
        const options = data.ResultData.map((item) => ({
          value: item.Id,
          label: item.ProposalStatus,
        }));

        setProposalStatusOptions(options);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const columns = [
    {
      title: "Proposal",
      dataIndex: "PrefixNumber",

      render: (text, record) => (
        <Link
          to={`/crm/view/proposal`}
          state={{ record }}
          className="text-decoration-none"
        >
          <Tag
            color={proposalStatusColors[status] || proposalStatusColors.Default}
            bordered={false}
            style={{
              padding: "4px 12px",
              fontWeight: 600,
              fontSize: 13,
            }}
          >
            {text}
          </Tag>
        </Link>
      ),
    },

    {
      title: "Subject",
      dataIndex: "subject",
      sorter: (a, b) => a.subject.localeCompare(b.subject),

      render: (text) =>
        text?.length > 23 ? (
          <Tooltip title={text}>
            <span>{text.substring(0, 23)}...</span>
          </Tooltip>
        ) : (
          text
        ),
    },

    {
      title: "Total",
      dataIndex: "total",
      align: "right",
      sorter: (a, b) => Number(a.total) - Number(b.total),

      render: (amount) => (
        <span className="fw-semibold text-success">
          <i className="fa-solid fa-indian-rupee-sign me-1"></i>
          {Number(amount).toLocaleString("en-IN")}
        </span>
      ),
    },

    {
      title: "Date",
      dataIndex: "datecreated",

      render: (datecreated) => (
        <>
          <i className="fa-regular fa-calendar-days text-primary me-2"></i>
          {dayjs(datecreated).format("DD-MM-YYYY") || "-"}
        </>
      ),
    },

    {
      title: "Open Till",
      dataIndex: "open_till",

      render: (open_till) => (
        <>
          <i className="fa-regular fa-calendar-check text-danger me-2"></i>
          {dayjs(open_till).format("DD-MM-YYYY") || "-"}
        </>
      ),
    },

    {
      title: "Status",
      dataIndex: "StatusName",

      render: (text, record) => {
        const getColor = (status) => {
          switch (status) {
            case "Draft":
              return "#6c757d";
            case "Sent":
              return "#0d6efd";
            case "Open":
              return "#0dcaf0";
            case "Revised":
              return "#ffc107";
            case "Declined":
              return "#dc3545";
            case "Accepted":
              return "#198754";
            default:
              return "#6c757d";
          }
        };

        return (
          <Select
            value={
              proposalStatusOptions.find(
                (item) => item.label === (text || "Draft"),
              )?.value
            }
            style={{ width: 100 }}
            options={proposalStatusOptions}
            onChange={(value) => {
              updateProposalStatus(record.id, value);
            }}
            dropdownStyle={{ zIndex: 9999 }}
            optionRender={(option) => (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 8,
                }}
              >
                <i
                  className="fa-solid fa-circle"
                  style={{
                    color: getColor(option.data.label),
                    fontSize: 10,
                  }}
                ></i>

                {option.data.label}
              </div>
            )}
            labelRender={({ value }) => {
              const status = proposalStatusOptions.find(
                (x) => x.value === value,
              );

              return (
                <span>
                  <i
                    className="fa-solid fa-circle me-2"
                    style={{
                      color: getColor(status?.label),
                      fontSize: 10,
                    }}
                  ></i>
                  {status?.label}
                </span>
              );
            }}
          />
        );
      },
    },

    {
      title: "Action",
      dataIndex: "action",
      align: "center",

      render: (_, record) => (
        <>
          {/* <Link className="action-set" to="#" data-bs-toggle="dropdown">
            <i className="fa fa-ellipsis-v btn border"></i>
          </Link>

          <ul className="dropdown-menu">
            <li>
              <Link
                // to={`/crm/viewproposal/${record.id}`}
                to={`/crm/view/proposal`}
                state={{ record }}
                className="dropdown-item"
              >
                <Eye className="me-2 text-info" />
                View
              </Link>
            </li>

            <li>
              <Link
                to={`/crm/update/proposal/${record.id}`}
                className="dropdown-item"
                state={{
                  proposalId: record.id,
                  record,
                  type: "customer",
                }}
              >
                <Edit className="me-2 text-secondary" />
                Edit
              </Link>
            </li>

             <li>
              <Link
                className="dropdown-item"
                data-bs-toggle="modal"
                data-bs-target="#delete-modal"
              >
                <Trash2 className="me-2 text-danger" />
                Delete
              </Link>
            </li> 
          </ul> */}

          <div className="action-table-data">
            <div className="edit-delete-action ">
              <Link
                to={`/crm/update/proposal/${record.id}`}
                className="me-2 p-2 shadow-sm"
                state={{
                  proposalId: record.id,
                  record,
                  type: "customer",
                }}
              >
               <i className="ti ti-pencil text-primary"></i>
              </Link>
            </div>
          </div>
        </>
      ),
    },
  ];

  const { id } = useParams();

  const [customerData, setCustomerData] = useState({});

  const getCustomerDetails = async () => {
    try {
      // setCustomerLoading(true);

      const response = await axios.get(
        `${BASE_CRM_URL}customers/GetCustomerDetails?CusId=${id}`,
      );

      if (response.data.Status) {
        setCustomerData(response.data.ResultData?.[0] || {});
      } else {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: response.data.message || "Unable to fetch customer details.",
        });
      }
    } catch (error) {
      console.error(error);
    }
  };
  useEffect(() => {
    if (id) {
      getCustomerDetails();
    }
  }, [id]);

  const [proposalCounts, setProposalCounts] = useState({
    TotalProposals: 0,
    TotalAmount: 0,
    DraftProposals: 0,
    SentProposals: 0,
    AcceptedProposals: 0,
  });

  const [selectedStatus, setSelectedStatus] = useState(0);
  const [proposalList, setProposalList] = useState([]);
  const [loading, setLoading] = useState(false);

  console.log(selectedStatus, proposalList, "proppppppppp");

  const getProposalCounts = async () => {
    try {
      const response = await fetch(
        `${BASE_CRM_URL}proposal/GetCustProposalCounts?RelId=${id}&RelType=customer`,
      );

      const data = await response.json();

      if (data.Status && data.ResultData.length > 0) {
        setProposalCounts(data.ResultData[0]);
      }
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    getProposalCounts();
    getProposalStatuses();
  }, []);

  const getProposals = async (status = 0) => {
    try {
      setLoading(true);

      const response = await fetch(
        `${BASE_CRM_URL}proposal/GetProposalsByRelId?relID=${id}&RelType=customer&Status=${status}`,
      );

      const data = await response.json();

      if (data.Status) {
        setProposalList(data.ResultData);
      } else {
        setProposalList([]);
      }
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getProposals(0);
  }, []);

  const updateProposalStatus = async (proposalId, statusId) => {
    try {
      const response = await fetch(
        `${BASE_CRM_URL}proposal/UpdateProposalStatus`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            id: proposalId,
            status: statusId,
          }),
        },
      );

      const data = await response.json();

      if (data.Status) {
        Swal.fire({
          icon: "success",
          title: "Success",
          text: data.Message,
          timer: 1200,
          showConfirmButton: false,
        });

        getProposals(id); // Reload your proposal list
      } else {
        Swal.fire({
          icon: "error",
          title: "Failed",
          text: data.Message,
        });
      }
    } catch (error) {
      console.log(error);
    }
  };



  return (
    <div>
      <div className="row g-3">
        {/* Draft */}
        <div
          className="col-12 col-sm-6 col-xl d-flex"
          onClick={() => {
            setSelectedStatus(0);
            getProposals(0);
          }}
        >
          <div className="card flex-fill  shadow-sm">
            <div className="card-body d-flex justify-content-between align-items-center py-2 px-3">
              <div  className="d-flex align-items-center gap-2 text-nowrap">
                <h4 className="mb-0 fw-bold">
                  {proposalCounts.TotalProposals}
                </h4>
                <p className="mb-0  fw-semibold">Total</p>
              </div>

              <div
                className="rounded-circle bg-info bg-opacity-10 d-flex align-items-center justify-content-center"
                style={{ width: 40, height: 40 }}
              >
                <i className="fa-solid fa-file-signature text-primary fs-4"></i>
              </div>
            </div>
          </div>
        </div>

        <div
          className="col-12 col-sm-6 col-xl d-flex"
          onClick={() => {
            setSelectedStatus(3);
            getProposals(3);
          }}
        >
          <div className="card flex-fill  shadow-sm">
            <div className="card-body d-flex justify-content-between align-items-center py-2 px-3">
              <div  className="d-flex align-items-center gap-2 text-nowrap">
                <h4 className="mb-0 fw-bold">
                  {proposalCounts.AcceptedProposals}
                </h4>
                <p className="mb-0  fw-semibold">Accepted</p>
              </div>

              <div
                className="rounded-circle bg-success bg-opacity-10 d-flex align-items-center justify-content-center"
                style={{ width: 40, height: 40 }}
              >
                <i className="fa-solid fa-circle-check text-success fs-4"></i>
              </div>
            </div>
          </div>
        </div>

        <div
          className="col-12 col-sm-6 col-xl d-flex"
          onClick={() => {
            setSelectedStatus(2);
            getProposals(2);
          }}
        >
          <div className="card flex-fill  shadow-sm">
            <div className="card-body d-flex justify-content-between align-items-center py-2 px-3">
              <div  className="d-flex align-items-center gap-2 text-nowrap">
                <h4 className="mb-1 fw-bold">{proposalCounts.SentProposals}</h4>
                <p className="mb-0  fw-semibold">Sent </p>
              </div>

              <div
                className="rounded-circle bg-info bg-opacity-10 d-flex align-items-center justify-content-center"
                style={{ width: 40, height: 40 }}
              >
                <i className="fa-solid fa-paper-plane text-info fs-4"></i>
              </div>
            </div>
          </div>
        </div>

        <div
          className="col-12 col-sm-6 col-xl d-flex"
          onClick={() => {
            setSelectedStatus(1);
            getProposals(1);
          }}
        >
          <div className="card flex-fill  shadow-sm ">
            <div className="card-body d-flex justify-content-between align-items-center py-2 px-3">
              <div  className="d-flex align-items-center gap-2 text-nowrap">
                <h4 className="mb-0 fw-bold">
                  {proposalCounts.DraftProposals}
                </h4>
                <p className="mb-0  fw-semibold">Draft </p>
              </div>

              <div
                className="rounded-circle bg-warning bg-opacity-10 d-flex align-items-center justify-content-center"
                style={{ width: 40, height: 40 }}
              >
                <i className="fa-solid fa-clock text-warning fs-4"></i>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="card table-list-card ">
        <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
          <div className="search-set">
       
          </div>
          <div className="d-flex table-dropdown my-xl-auto right-content align-items-center flex-wrap row-gap-3">
            {/* <div className="me-3">
            <Select
              defaultValue="2026"
              style={{ width: 120 ,height: 34}}
              options={[
                { value: "2026", label: "2026" },
                { value: "2025", label: "2025" },
                { value: "2024", label: "2024" },
              ]}
            />
            </div> */}

            <div className="page-btn">
              <Link
                to="/crm/add/proposal"
                className="btn btn-success btn-sm me-2"
                state={{
                  type: "customer",
                  customerId: customerData.customerId,
                  record: customerData,
                }}
              >
                <i className="ti ti-circle-plus fs-4 "> </i>
              </Link>
            </div>
          </div>
        </div>

        <div className="card-body">
          <div className=" table-responsive">
            {loading ? (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "250px", // adjust height if needed
                }}
              >
                <Spin size="large" />
              </div>
            ) : (
              <Table columns={columns} dataSource={proposalList} />
            )}
          </div>
        </div>
      </div>

      <CommonFooter />
    </div>
  );
};

export default ProposalsTab;
